module.exports = __webpack_public_path__ + "static/media/dimentha-work-intro-bg.1ef079c3.svg";